import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-br from-gray-800 via-gray-900 to-black text-white overflow-hidden">
      {/* Decorative Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-brand-green rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-green rounded-full blur-3xl transform translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-16 py-16">
        {/* Top Row */}
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between mb-12 gap-6">
          <div>
            <img
              src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/c96bfb198278da73880d302267f14c20.png"
              alt="A and B Concrete LLC"
              className="h-16 w-auto mb-3"
            />
            <p className="font-serif italic text-lg text-white/90">Building Excellence Since 2014</p>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 bg-brand-green/20 backdrop-blur-sm px-5 py-3 rounded-full border border-brand-green/30">
              <i className="ri-shield-check-line text-xl text-brand-green"></i>
              <span className="text-sm font-medium whitespace-nowrap">Licensed & Insured LLC</span>
            </div>
          </div>
        </div>

        {/* Middle Navigation */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4 uppercase tracking-wide flex items-center gap-2 text-brand-green">
              <i className="ri-tools-line"></i>
              Services
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/service/concrete" className="text-white/80 hover:text-brand-green hover:translate-x-1 transition-all text-sm cursor-pointer inline-block">
                  Concrete
                </Link>
              </li>
              <li>
                <Link to="/service/patio" className="text-white/80 hover:text-brand-green hover:translate-x-1 transition-all text-sm cursor-pointer inline-block">
                  Patios
                </Link>
              </li>
              <li>
                <Link to="/service/pavers" className="text-white/80 hover:text-brand-green hover:translate-x-1 transition-all text-sm cursor-pointer inline-block">
                  Pavers
                </Link>
              </li>
              <li>
                <Link to="/service/drywall" className="text-white/80 hover:text-brand-green hover:translate-x-1 transition-all text-sm cursor-pointer inline-block">
                  Drywall
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-lg mb-4 uppercase tracking-wide flex items-center gap-2 text-brand-green">
              <i className="ri-building-line"></i>
              Company
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-brand-green hover:translate-x-1 transition-all text-sm cursor-pointer inline-block">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-brand-green hover:translate-x-1 transition-all text-sm cursor-pointer inline-block">
                  All Services
                </Link>
              </li>
              <li>
                <a href="/#service-area" className="text-white/80 hover:text-brand-green hover:translate-x-1 transition-all text-sm cursor-pointer inline-block">
                  Service Area
                </a>
              </li>
              <li>
                <a href="/#reviews" className="text-white/80 hover:text-brand-green hover:translate-x-1 transition-all text-sm cursor-pointer inline-block">
                  Reviews
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4 uppercase tracking-wide flex items-center gap-2 text-brand-green">
              <i className="ri-contacts-line"></i>
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:5743776776" className="text-white/80 hover:text-brand-green transition-colors text-sm flex items-center gap-2 cursor-pointer group">
                  <div className="w-8 h-8 flex items-center justify-center bg-brand-green/20 rounded-full group-hover:bg-brand-green/30 transition-colors">
                    <i className="ri-phone-line text-brand-green"></i>
                  </div>
                  (574) 377-6776
                </a>
              </li>
              <li>
                <a href="mailto:charlys4776@gmail.com" className="text-white/80 hover:text-brand-green transition-colors text-sm flex items-center gap-2 cursor-pointer break-all group">
                  <div className="w-8 h-8 flex items-center justify-center bg-brand-green/20 rounded-full group-hover:bg-brand-green/30 transition-colors">
                    <i className="ri-mail-line text-brand-green"></i>
                  </div>
                  charlys4776@gmail.com
                </a>
              </li>
              <li className="text-white/80 text-sm flex items-start gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-brand-green/20 rounded-full mt-0">
                  <i className="ri-map-pin-line text-brand-green"></i>
                </div>
                <span>1905 Crescent Dr<br />Warsaw, IN 46580</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="font-bold text-lg mb-4 uppercase tracking-wide flex items-center gap-2 text-brand-green">
              <i className="ri-share-line"></i>
              Follow Us
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="https://www.facebook.com/aandbconcretellc"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/80 hover:text-brand-green transition-all cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-brand-green/20 rounded-full group-hover:bg-brand-green/30 group-hover:scale-110 transition-all">
                  <i className="ri-facebook-fill text-xl text-brand-green"></i>
                </div>
                <span className="text-sm">Facebook</span>
              </a>
              <a
                href="https://www.instagram.com/aandbconcretellc"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/80 hover:text-brand-green transition-all cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-brand-green/20 rounded-full group-hover:bg-brand-green/30 group-hover:scale-110 transition-all">
                  <i className="ri-instagram-line text-xl text-brand-green"></i>
                </div>
                <span className="text-sm">Instagram</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/80">
            <p>© {currentYear} A and B Concrete LLC. All Rights Reserved.</p>
            <div className="flex items-center gap-4">
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-2-line"></i>
                Licensed & Insured in Indiana
              </span>
              <a 
                href="https://www.meltgraphicsprint.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-brand-green transition-colors cursor-pointer flex items-center gap-2"
              >
                <img 
                  src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/c095d581dc1845a3b1c3b759951a8d5b.png"
                  alt="Melt Graphics"
                  className="h-5 w-auto"
                />
                <span>Powered by Melt Graphics</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
